// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--NfE9t","link":"_0fce717cdb--link--SzQFa"};